import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import { useLaunchData } from 'contexts/LaunchData';
import { NextSeo } from 'next-seo';
import React from 'react';
import useSWR from 'swr';
import { swrFetcher } from 'utils/api';

export default function SkinTopics() {
  const { notifications } = useLaunchData();

  const { data: skinTopics } = useSWR(
    '/api/seo/skinTopics',
    swrFetcher,
    {
      fallbackData: [],
    }
  );

  return (
    <div>
      <NextSeo
        title="皮膚症狀分類 | 護膚品推薦 | Sorra"
        description="根據皮膚症狀找到最適合的護膚品推薦。痘痘粉刺、敏感肌、乾燥、色素沉澱、老化鬆弛等常見皮膚問題，查看真實用家評價。"
        canonical="https://www.sorra.net/skinTopics"
      />
      <main>
        <Menubar
          props={{
            homeExtend: false,
            sourceUI: 'Keywords',
          }}
        />

        <div
          className={
            'globals-centerContentsMargin' +
            (notifications.length > 0 ? ' withNoti' : '')
          }
        >
          <MaxWidthContainer className="px-4">
            <div
              className={`flex w-[100%] flex-wrap items-center gap-1 py-[16px] lg:py-[32px]`}
            >
              首頁 &gt; 皮膚症狀
            </div>
          </MaxWidthContainer>
          <MaxWidthContainer className="font-noto-sans px-4 text-sorra-gray-900">
            <h1 className="pb-10 text-4xl font-bold">皮膚症狀</h1>

            <div className="flex flex-col gap-x-12 gap-y-8 pb-20">
              {skinTopics.map((topic, index) => (
                <div key={topic.id}>
                  <h2 className={`mb-4 text-xl font-normal text-[#4A4A4A] ${index === 0 ? 'mt-0' : ''}`}>
                    {topic.name}
                  </h2>
                  <div className="mb-4 flex flex-row flex-wrap gap-x-6">
                    {topic.keywords && topic.keywords.map((kw) => (
                      <div
                        key={kw.id}
                        className="flex cursor-pointer items-center gap-x-1 text-lg"
                      >
                        <img
                          src="/svgs/index-partnership-arrow.svg"
                          className="h-6 w-6"
                        />
                        <a
                          href={`/skinTopics/${topic.slug}/${kw.slug}`}
                          className="text-lg"
                        >
                          {kw.keyword}
                        </a>
                      </div>
                    ))}
                  </div>

                  {index < skinTopics.length - 1 && (
                    <div className="border-b border-sorra-gray-100 pb-8"></div>
                  )}
                </div>
              ))}
            </div>
          </MaxWidthContainer>

          <Footer />

          <MobileTabBar props={{ highlighted: 'keywords' }} />
        </div>
      </main>
    </div>
  );
}
